export default __webpack_public_path__ + "static/media/light_home_banner_bg.2d8aa438.png";